import React, { useEffect, useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import axios from 'axios';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Divider,
  CircularProgress,
  Button,
  Grid,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const apiUrl = process.env.REACT_APP_API_URL;

const ReproductionRecordDetails = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [record, setRecord] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${apiUrl}/reproduction-clinic/record/${id}`)
      .then((res) => {
        setRecord(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching record details:', err);
        setLoading(false);
      });
  }, [id]);

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!record) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h6" color="error">
          {t('reproduction.recordNotFound')}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ textAlign: 'center', mb: 2 }}>
        <Typography variant="h4" fontWeight="bold">
          {t('reproduction.recordDetails')}
        </Typography>
      </Box>

      <Box sx={{ textAlign: 'right', mb: 2 }}>
        <Button
          variant="outlined"
          component={RouterLink}
          to="/ReproductionPage"
        >
          {t('back')}
        </Button>
      </Box>

      <Divider sx={{ mb: 3 }} />

      <Card elevation={3}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {record.horse_name || record.inside_horse_name}
          </Typography>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1">
                <strong>{t('reproduction.stallion')}:</strong>{' '}
                {record.stallion_name}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1">
                <strong>{t('reproduction.date')}:</strong>{' '}
                {formatDate(record.insemination_date)}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1">
                <strong>{t('reproduction.semenType')}:</strong>{' '}
                {record.semen_type}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="body1">
                <strong>{t('directInsemination.semenSource')}:</strong>{' '}
                {record.semen_source_type}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                <strong>{t('directInsemination.notes')}:</strong>{' '}
                {record.notes || '-'}
              </Typography>
            </Grid>
          </Grid>

          {record.procedures && record.procedures.length > 0 && (
            <>
              <Divider sx={{ my: 3 }} />
              <Typography variant="h6" gutterBottom>
                {t('directInsemination.procedures')}
              </Typography>
              {record.procedures.map((proc, idx) => (
                <Box key={idx} sx={{ mb: 1 }}>
                  <Typography variant="body2">
                    {proc.procedure_name}

                    {false && <>- {proc.custom_price} ريال</>}
                  </Typography>
                </Box>
              ))}
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReproductionRecordDetails;
